import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@core/api";
import { addressKeys } from "./addressKeys";

export const useDeleteAddress = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (addressId: string) => apiClient.remove<void>(`/addresses/${addressId}`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: addressKeys.lists() });
    },
  });
};
